import styled from "styled-components";

interface LayoutProps {
  $basis?: string;
}

export const FiltersWrapper = styled.div`
  position: relative;
  z-index: 10;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 16px;
  flex: 1 1 0;
  min-width: 0;
  width: 100%;
`;

export const FieldWrapper = styled.div<LayoutProps>`
  position: relative;
  z-index: 2;
  flex: 1 1 180px;
  width: 0;
  min-width: 180px;

  @media (max-width: 768px) {
    flex-basis: 100%;
    min-width: 0;
    width: 100%;
  }
`;

export const DateRangeWrapper = styled.div<LayoutProps>`
  position: relative;
  z-index: 1;
  flex: 2 1 370px;
  width: 0;
  min-width: 370px;

  @media (max-width: 768px) {
    flex-basis: 100%;
    min-width: 0;
    width: 100%;
  }
`;
